import React, { useState } from 'react';

const API_BASE = 'https://arkaniomran.ir/api';

const ActivationForm = ({ isVisible }) => {
  const [hwid, setHwid] = useState('');
  const [name, setName] = useState('');
  const [mobile, setMobile] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // اعتبارسنجی پر بودن فیلدها
    if (!hwid.trim() || !name.trim() || !mobile.trim()) {
      alert('لطفاً تمام فیلدها (HWID، نام و نام‌خانوادگی، شماره موبایل) را تکمیل کنید.');
      return;
    }
    setLoading(true);
    setResult(null);
    try {
      const res = await fetch(`${API_BASE}/activate.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          hwid: hwid.trim(),
          name: name.trim(),
          mobile: mobile.trim()
        })
      });
      const data = await res.json();
      setResult(data);
    } catch (err) {
      setResult({ success: false, error: 'خطا در ارتباط با سرور' });
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      alert('✅ کلید فعال‌سازی کپی شد!');
    } catch (err) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      alert('✅ کلید فعال‌سازی کپی شد!');
    }
  };

  return (
    <div className={`page-section ${isVisible ? '' : 'hidden-page'}`}>
      <div className="container mx-auto px-4 py-16 max-w-lg">
        <div className="glass-panel p-8 rounded-3xl border border-slate-700">
          <h2 className="text-2xl font-black text-yellow-400 mb-6 text-center">فعال‌سازی EtaNex</h2>
          
          {/* هشدار Run as Administrator */}
          <div className="mb-6 p-4 bg-orange-500/10 border border-orange-500/30 rounded-xl text-orange-300 text-sm">
            <div className="font-bold mb-2">⚠️ نکته مهم:</div>
            <ul className="list-disc list-inside space-y-1 text-right">
              <li>برای فعال‌سازی <span className="font-bold text-white">EtaNex</span>، حتماً برنامه را با <span className="font-mono bg-black/30 px-1 rounded">Run as Administrator</span> اجرا کنید.</li>
              <li>برای کار با <span className="font-bold text-white">ETABS</span> یا <span className="font-bold text-white">تعامل</span>، هر دو نرم‌افزار (EtaNex و ETABS) را با <span className="font-mono bg-black/30 px-1 rounded">Run as Administrator</span> اجرا نمایید.</li>
              <li>در غیر این صورت ارتباط برقرار نمی‌شود و فعال‌سازی انجام نخواهد شد.</li>
              <li>برای اطلاع دقیق تر از نحوه کار کردن حتما به مطالب درج شده در کانال اطلاع رسانی ما در پیامرسان های بله و تلگرام که در ابتدای سایت میباشد مراجعه نمایید.</li>
            </ul>
          </div>

          <p className="text-slate-300 text-sm mb-8 text-center">
            کد HWID نمایش‌داده‌شده در برنامه را وارد کنید. همچنین نام و شماره موبایل خود را جهت ثبت لایسنس تکمیل نمایید.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-slate-400 text-xs block mb-1">کد HWID</label>
              <input 
                required
                type="text"
                value={hwid}
                onChange={e => setHwid(e.target.value)}
                placeholder="مثلاً 4F3A2B..."
                className="w-full bg-slate-900 border border-slate-700 rounded-lg p-3 text-white focus:border-yellow-500 outline-none font-mono"
                style={{ direction: 'ltr', textAlign: 'left' }}
              />
            </div>
            <div>
              <label className="text-slate-400 text-xs block mb-1">نام و نام خانوادگی</label>
              <input 
                required
                type="text"
                value={name}
                onChange={e => setName(e.target.value)}
                placeholder="نام و نام خانوادگی خود را وارد کنید"
                className="w-full bg-slate-900 border border-slate-700 rounded-lg p-3 text-white focus:border-yellow-500 outline-none"
              />
            </div>
            <div>
              <label className="text-slate-400 text-xs block mb-1">شماره موبایل</label>
              <input 
                required
                type="text"
                value={mobile}
                onChange={e => setMobile(e.target.value)}
                placeholder="09xxxxxxxxx"
                className="w-full bg-slate-900 border border-slate-700 rounded-lg p-3 text-white focus:border-yellow-500 outline-none"
                style={{ direction: 'ltr', textAlign: 'left' }}
              />
            </div>
            <button 
              type="submit"
              disabled={loading}
              className="w-full bg-yellow-500 text-slate-900 font-bold py-3 rounded-xl hover:bg-yellow-400 transition-colors disabled:opacity-50"
            >
              {loading ? 'در حال ارسال...' : 'دریافت کلید فعال‌سازی'}
            </button>
          </form>

          {result && (
            <div className={`mt-6 p-4 rounded-xl text-center ${result.success ? 'bg-green-500/20 border border-green-500/30 text-green-300' : 'bg-red-500/20 border border-red-500/30 text-red-300'}`}>
              {result.success ? (
                <>
                  <div className="font-bold text-lg mb-3">کلید فعال‌سازی شما:</div>
                  <div className="bg-slate-800 rounded-lg p-3 mb-3 flex items-center justify-between gap-2 flex-wrap">
                    <code className="text-yellow-300 font-mono text-base break-all">{result.license_key}</code>
                    <button
                      onClick={() => copyToClipboard(result.license_key)}
                      className="bg-slate-600 hover:bg-slate-500 text-white px-3 py-1 rounded-md text-sm transition-colors flex items-center gap-1"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                      </svg>
                      کپی
                    </button>
                  </div>
                  <div className="text-xs">{result.message}</div>
                </>
              ) : (
                <div>{result.error || result.message}</div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ActivationForm;